import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import {ThemeProvider} from '@mui/styles';
import Main from './pages/Main';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import getStore, {history} from './store/index'

import theme from './style/theme';
import './index.css';
import './style/index.scss';
import './i18n';

const store = getStore()
ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <Main history={history}/>
        </ThemeProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
